<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết Merchant cộng tác viên</h1>
      <div class="" style="float: right">
        <button @click="backToList" class="btn btn-outline-secondary ml-2">Quay lại</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin Merchant</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên người đại diện<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.customerName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số diện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.mobile }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Email<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.email }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tên merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.merchantName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.address }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngành hàng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.mccName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Loại MC<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p
                  class="form-control-plaintext f12"
                  v-if="this.dataDetail.customerType === 'COMPANY'"
                >
                  Doanh nghiệp
                </p>
                <p
                  class="form-control-plaintext f12"
                  v-if="this.dataDetail.customerType === 'INDIVIDUAL'"
                >
                  Cá nhân
                </p>
                <p
                  class="form-control-plaintext f12"
                  v-if="this.dataDetail.customerType === 'HOUSEHOLD'"
                >
                  Hộ gia đình
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Số TK M-Biz Fast<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.mbizFastNo }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngày dự kiến ký HĐ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.expectedSignDate }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.description }}</p>
              </div>
            </div>
            <div class="table-responsive mt-4">
              <table class="table table-bordered">
                <tr>
                  <th>Nhóm dịch vụ</th>
                  <th>Dịch vụ</th>
                  <th>Trạng thái</th>
                  <th>Số tiền</th>
                  <th>Lý do từ chối</th>
                </tr>
                <tr v-for="(item, index) in servicePacksList" :key="index">
                  <td>{{ item.service_name }}</td>
                  <td>
                    <div v-for="(itemn, indexn) in item.serviceType" :key="indexn">{{ itemn }}</div>
                  </td>
                  <td>
                    <div>
                      <span class="badge badge-secondary" v-if="item.servicePackstatus === 'NEW'"
                        >Mới tạo</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="item.servicePackstatus === 'WAIT_RECEIVE'"
                        >Chờ nhận</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="item.servicePackstatus === 'DONE_RECEIVE'"
                        >Đã nhận</span
                      >
                      <span class="badge badge-warning" v-if="item.servicePackstatus === 'REJECT'"
                        >Bị từ chối</span
                      >
                      <span class="badge badge-danger" v-if="item.servicePackstatus === 'FAIL'"
                        >Hết hạn</span
                      >
                    </div>
                  </td>
                  <td>{{ item.bonusMoney }}</td>
                  <td>{{ item.rejectReason }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <div class="form-detail">
            <h1>Thông tin</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12"></p>
                {{ this.dataDetail.createAt }}
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian gán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12"></p>
                {{ this.dataDetail.assignDay }}
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Người gán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ this.dataDetail.assignerName }} - {{ this.dataDetail.assignerEmail }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tiếp nhận<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.doneAssignDay }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Sales Chăm sóc<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ this.dataDetail.activeSaleName }} - {{ this.dataDetail.activeSaleEmail }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Cộng tác viên<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ this.dataDetail.agentName }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Lịch sử chi hoa hồng</h1>
            <div class="table-responsive mt-4">
              <table class="table table-bordered">
                <tr>
                  <th>Nhóm dịch vụ</th>
                  <th>Thời gian chi</th>
                  <th>Người chi</th>
                </tr>
                <tr v-for="(item, index) in payBonusHistories" :key="index">
                  <td>{{ item.service_bonus_name }}</td>
                  <td>{{ item.payDay }}</td>
                  <td>{{ item.userPayName }}<br />{{ item.userPayEmail }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  export default {
    data() {
      return {
        loading: true,
        customerId: this.$route.params.customerId,
        dataDetail: [],
        servicePacksList: [],
        payBonusHistories: [],
        groupService: [],
        groupServiceKey: {},
      }
    },
    mounted() {
      this.fetchData()
      this.getServiceList()
    },
    methods: {
      backToList() {
        this.$router.push('/assign-mc')
      },
      // ds nhóm dịch vụ
      async getServiceList() {
        this.loading = true
        try {
          const data = await AgentService.getServiceList()
          if (data.success) {
            data.data.groupService.map(e => {
              this.groupService.push({ id: e.service, text: e.name })
              this.groupServiceKey[e.service] = e.name
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // dữ liệu chung
      async fetchData() {
        this.loading = true
        try {
          const data = await AgentService.mcDetail({
            customerId: this.customerId,
          })
          if (data.success) {
            this.dataDetail = data.data
            this.servicePacksList = data.data.servicePacksList
            data.data.servicePacksList.map((e, index) => {
              if (this.groupServiceKey[e.servicePackCode]) {
                this.servicePacksList[index].service_name = this.groupServiceKey[e.servicePackCode]
              }
            })
            this.payBonusHistories = data.data.payBonusHistories
            data.data.payBonusHistories.map((e, index) => {
              if (this.groupServiceKey[e.servicePackCode]) {
                this.payBonusHistories[index].service_bonus_name =
                  this.groupServiceKey[e.servicePackCode]
              }
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
